import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { hub } from "@/lib/hub-client";

export interface Favorite {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  price_tokens: number;
  price_kind: "fixed" | "variable";
  max_price_tokens: number | null;
  delivery_mode: string;
  rating_avg: number;
  rating_count: number;
  partner_slug: string;
  partner_name: string;
  favorited_at: string;
}

export function useFavorites() {
  return useQuery({
    queryKey: ["favorites"],
    queryFn: async () => {
      const res = await hub.GET<{ items: Favorite[] }>("/v1/me/favorites");
      if (!res.data) throw new Error("favorites fetch failed");
      return res.data.items;
    },
  });
}

export function useToggleFavorite(outcomeId: string, isFav: boolean) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const path = `/v1/me/favorites/${outcomeId}`;
      const res = isFav
        ? await hub.DELETE(path)
        : await hub.POST(path, { body: {} });
      if (!res.response.ok) throw new Error("favorite toggle failed");
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["favorites"] }),
  });
}
